/* import __COLOCATED_TEMPLATE__ from './share-modal.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { modifier } from 'ember-modifier';

export default class ShareModal extends Component {
    @service intl;
    @service('aditools-site') siteconfig;
    @service hashService;
    @tracked copyResultClass = null;
    @tracked copyResultMessage = null;
    @tracked copyResult = null;

    ////////////////////////////////////////////////////////////////////////////////
    // Component Actions                                                          //
    ////////////////////////////////////////////////////////////////////////////////

    get currentUrl() {
        return `${this.siteconfig.AdcDriverUrl}/${this.hashService.locationHash}`;
    }

    sharePopup = modifier(() => {
        this.copyResultClass = '';
        this.copyResultMessage = '';
        this.copyResult = '';
    });

    @action copyClick() {
        navigator.clipboard.writeText(this.currentUrl).then(
            () => {
                this.copyResultClass = 'share-confirmation-ok';
                this.copyResultMessage = this.intl.t('icon_modal.share.copy');
                this.copyResult = 'success';
            },
            () => {
                this.copyResultClass = 'share-confirmation-ng';
                this.copyResultMessage = this.intl.t('icon_modal.share.copyFail');
                this.copyResult = 'fail';
            },
        );
    }
}
